import { appConfig } from '@/shared/config/app-config';

function getRegion(): string | undefined {
    return appConfig.userPoolId?.split('_')[0] || undefined;
}

/**
 * URL of Amazon's Advanced Security Data script for the configured pool's
 * region, or undefined when the pool id isn't set (e.g. local dev). Rendered as
 * a hoisted <script> by ThreatProtectionScript.
 */
export function getThreatProtectionScriptSrc(): string | undefined {
    const region = getRegion();
    if (!region) return undefined;
    return `https://amazon-cognito-assets.${region}.amazoncognito.com/amazon-cognito-advanced-security-data.min.js`;
}

export function getEncodedData(email: string): string | undefined {
    const { userPoolId, userPoolClientId } = appConfig;
    if (!userPoolId || !userPoolClientId) return undefined;

    try {
        return window.AmazonCognitoAdvancedSecurityData?.getData(
            email,
            userPoolId,
            userPoolClientId,
        );
    } catch {
        return undefined;
    }
}
